import { cva } from "class-variance-authority";

export const buttonVariants = cva("w-fit appearance-none rounded-lg font-normal text-nowrap transition-colors duration-150", {
  variants: {
    variant: {
      contained: "border text-white",
      outlined: "border bg-transparent",
      text: "bg-transparent",
    },
    color: {
      primary: "#1a2b45",
      success: "#99C32C",
      warning: "#E5A000",
      danger: "#EC221F",
    },
    size: {
      small: "px-[10.5px] py-3 text-sm",
      medium: "px-3 text-base h-[40px]",
      large: "px-8 py-2 text-lg",
    },
    disabled: {
      true: "cursor-not-allowed",
      false: "cursor-pointer",
    },
  },
  compoundVariants: [
    {
      variant: "contained",
      color: "primary",
      disabled: false,
      className: "border-[#1a2b45] bg-[#1a2b45] hover:border-[#2B4166] hover:bg-[#2B4166]",
    },
    {
      variant: "contained",
      color: "success",
      disabled: false,
      className: "border-[#99C32C] bg-[#99C32C] hover:border-[#84A925] hover:bg-[#84A925]",
    },
    {
      variant: "contained",
      color: "warning",
      disabled: false,
      className: "border-[#E5A000] bg-[#E5A000] hover:border-[#C98C00] hover:bg-[#C98C00]",
    },
    {
      variant: "contained",
      color: "danger",
      disabled: false,
      className: "border-[#EC221F] bg-[#EC221F] hover:border-[#CF1A17] hover:bg-[#CF1A17]",
    },
    {
      variant: "contained",
      color: ["primary", "success", "warning", "danger"],
      disabled: true,
      className: "border-[#D1D1D1] bg-[#D1D1D1] text-[#B3B3B3]",
    },
    {
      variant: "outlined",
      color: "primary",
      disabled: false,
      className: "border-[#1a2b45] text-[#1a2b45] hover:bg-[#E2E7F4]",
    },
    {
      variant: "outlined",
      color: "success",
      disabled: false,
      className: "border-[#99C32C] text-[#99C32C] hover:bg-[#F9FFEA]",
    },
    {
      variant: "outlined",
      color: "warning",
      disabled: false,
      className: "border-[#E5A000] text-[#E5A000] hover:bg-[#FFF1C2]",
    },
    {
      variant: "outlined",
      color: "danger",
      disabled: false,
      className: "border-[#EC221F] text-[#EC221F] hover:bg-[#FEE9E7]",
    },
    {
      variant: "outlined",
      color: ["primary", "success", "warning", "danger"],
      disabled: true,
      className: "border-[#D1D1D1] text-[#D1D1D1] bg-transparent",
    },
    {
      variant: "text",
      color: "primary",
      disabled: false,
      className: "text-[#1a2b45] hover:bg-[#1a2b45] hover:text-white",
    },
    {
      variant: "text",
      color: "success",
      disabled: false,
      className: "text-[#99C32C] hover:bg-[#99C32C] hover:text-white",
    },
    {
      variant: "text",
      color: "warning",
      disabled: false,
      className: "text-[#E5A000] hover:bg-[#E5A000] hover:text-white",
    },
    {
      variant: "text",
      color: "danger",
      disabled: false,
      className: "text-[#EC221F] hover:bg-[#EC221F] hover:text-white",
    },
    {
      variant: "text",
      color: ["primary", "success", "warning", "danger"],
      disabled: true,
      className: "text-[#B3B3B3]",
    },
  ],
  defaultVariants: {
    variant: "contained",
    color: "primary",
    disabled: false,
    size: "medium",
  },
});
